/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit2_TInputs */

const en_minifier_pit2_t = /** @type {(inputs: Minifier_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newlines inside string values are preserved, and that is correct`)
};

const ko_minifier_pit2_t = /** @type {(inputs: Minifier_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문자열 값 안의 줄바꿈은 보존되며, 그것이 맞습니다`)
};

const ja_minifier_pit2_t = /** @type {(inputs: Minifier_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字列値の中の改行は保たれ、それが正しいです`)
};

/**
* | output |
* | --- |
* | "Newlines inside string values are preserved, and that is correct" |
*
* @param {Minifier_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit2_t = /** @type {((inputs?: Minifier_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit2_t(inputs)
	if (locale === "ko") return ko_minifier_pit2_t(inputs)
	return ja_minifier_pit2_t(inputs)
});